import React from "react";
import PropTypes from "prop-types";
import { Roller } from "react-css-spinners";
import clsx from "clsx";
import styles from "./Switch.module.scss";

const Switch = ({
  isChecked = false,
  isDisabled = false,
  onToggle = () => {},
  isLoading = false,
  className = "",
  width = 48,
  height = 28,
  knobPadding = 3,
  // Below 1280px: no reserved spinner slot on the right, the spinner overlays the toggle instead,
  // so the toggle sits flush with the right edge (opt-in, used by the Student settings page)
  isCompact = false,
}) => {
  const knobSize = height - knobPadding * 2;
  const translateX = width - knobSize - knobPadding * 2;

  return (
    <div
      className={clsx(
        "flex justify-between items-center mr-2",
        isCompact && "relative shrink-0 max-xl:mr-0",
      )}
    >
      <div
        className={clsx(
          styles.toggle,
          isDisabled || isLoading
            ? styles.disabled
            : isChecked
              ? styles.active
              : "",
          className,
        )}
        style={{
          width,
          height,
          padding: knobPadding,
        }}
        onClick={() => !isDisabled && !isLoading && onToggle(!isChecked)}
        role="switch"
        aria-checked={isChecked}
        aria-disabled={isDisabled || isLoading}
      >
        <div
          className={clsx(
            styles.check,
            isDisabled || isLoading
              ? styles.disabled
              : isChecked
                ? styles.transformation
                : "",
          )}
          style={{
            width: knobSize,
            height: knobSize,
            transform: isChecked
              ? `translateX(${translateX}px)`
              : "translateX(0px)",
          }}
        />
      </div>

      <div
        className={clsx(
          "w-8 h-8 flex items-center justify-center",
          isCompact &&
            "max-xl:absolute max-xl:left-1/2 max-xl:top-1/2 max-xl:-translate-x-1/2 max-xl:-translate-y-1/2 max-xl:pointer-events-none",
        )}
      >
        <Roller
          size={30}
          color="#B2B2B2"
          className={isLoading ? "" : "opacity-0 pointer-events-none"}
        />
      </div>
    </div>
  );
};

Switch.propTypes = {
  className: PropTypes.string,
  isChecked: PropTypes.bool,
  isLoading: PropTypes.bool,
  isDisabled: PropTypes.bool,
  onToggle: PropTypes.func,
  width: PropTypes.number,
  height: PropTypes.number,
  knobPadding: PropTypes.number,
  isCompact: PropTypes.bool,
};

export default Switch;
